(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SchedulingV2Controller', SchedulingV2Controller);

    SchedulingV2Controller.$inject = ['$scope', '$state', '$stateParams', 'entity'];

    function SchedulingV2Controller($scope, $state, $stateParams, entity) {
        var vm = this;
        vm.serviceItemId = $stateParams.id;
        vm.serviceItem = entity;


    }
})();
